import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { callLoader } from "@/redux/Loader/actions";
import { showToast } from "@/redux/Toast/actions";

/**
 * Standard load pattern for FCL report pages (matches list pages).
 */
export const useFclReportLoader = (fetchAction, buildApiParams) => {
    const dispatch = useDispatch();

    const loadReport = useCallback(
        async (filters) => {
            dispatch(callLoader(1));
            try {
                await dispatch(fetchAction(filters));
            } catch {
                dispatch(showToast("Failed to load report", "error"));
            } finally {
                dispatch(callLoader(0));
            }
        },
        [dispatch, fetchAction, buildApiParams]
    );

    return { loadReport };
};

/** Load report once when the page mounts (initial filter state). */
export const useMountReportLoad = (loadReport, filters) => {
    const filtersRef = useRef(filters);
    filtersRef.current = filters;

    useEffect(() => {
        loadReport(filtersRef.current);
    }, [loadReport]);
};
